'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _unfetch = require('unfetch');

var _unfetch2 = _interopRequireDefault(_unfetch);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

if ((typeof window === 'undefined' ? 'undefined' : _typeof(window)) === 'object' && !window.fetch && typeof fetch === 'undefined') {
  window.fetch = _unfetch2.default;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cheesecakelabs/fetch/utils/polyfill.js
// module id = 584
// module chunks = 0